import { ApiService } from '../apiService'
import type {
  UserProfileDto,
  UpdateUserProfileDto,
} from '../../types/profile'

// Current location types
export interface UpdateCurrentLocationRequest {
  latitude: number
  longitude: number
  accuracy?: number
  timestamp?: string
}

export interface CurrentLocationResponse {
  success: boolean
  updatedAt: string
}

export interface UserLocationDto {
  userId: string
  latitude: number
  longitude: number
  accuracy?: number
  timestamp: string
}

// Request type for setting avatar/cover from media
export interface SetProfileMediaRequest {
  mediaId: string
}

export const profileApi = {
  // ====================
  // USER PROFILE
  // ====================

  // Get current user's profile
  getMyProfile: () => ApiService.get<UserProfileDto>('/api/me/profile'),

  // Update current user's profile
  updateMyProfile: (data: UpdateUserProfileDto) =>
    ApiService.post<UserProfileDto>('/api/me/profile', data),

  // ====================
  // AVATAR & COVER PHOTO
  // ====================

  // Set avatar from existing media file
  setAvatar: (mediaId: string) =>
    ApiService.put<UserProfileDto>('/api/me/profile/avatar', { mediaId }),

  // Clear avatar image
  clearAvatar: () =>
    ApiService.delete<UserProfileDto>('/api/me/profile/avatar'),

  // Set cover photo from existing media file
  setCoverPhoto: (mediaId: string) =>
    ApiService.put<UserProfileDto>('/api/me/profile/cover', { mediaId }),

  // Clear cover photo
  clearCoverPhoto: () =>
    ApiService.delete<UserProfileDto>('/api/me/profile/cover'),

  // Get user profile by ID
  getUserProfile: (id: string) => ApiService.get<UserProfileDto>(`/api/users/${id}/profile`),

  // Update user profile by ID (admin/moderator function)
  updateUserProfile: (id: string, data: UpdateUserProfileDto) =>
    ApiService.put<UserProfileDto>(`/api/users/${id}/profile`, data),

  // ====================
  // CURRENT LOCATION
  // ====================

  // Update current user's real-time location
  updateCurrentLocation: (data: UpdateCurrentLocationRequest) =>
    ApiService.put<CurrentLocationResponse>('/api/me/current-location', data),

  // Get current user's last reported location
  getMyCurrentLocation: () =>
    ApiService.get<UserLocationDto>('/api/me/current-location'),

  // Get a user's last reported location (for friends/group members)
  getUserLocation: (userId: string) =>
    ApiService.get<UserLocationDto>(`/api/users/${userId}/location`),

  // Get locations of multiple users (friends, group members, etc.)
  getUsersLocations: (userIds: string[]) =>
    ApiService.post<UserLocationDto[]>('/api/users/locations', { userIds }),
}
